export default __webpack_public_path__ + "static/media/customer-service.accaf63b.png";